import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen p-6">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8 text-secondary">Privacy Policy</h1>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
          <p className="leading-relaxed">
            Welcome to Fatherhood Tech Inc. This privacy policy explains how we use any personal information we collect about you when you use this website.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
          <p className="leading-relaxed">
            We collect information about you when you register with us, place an order for products or services, or use our website. We also collect information when you voluntarily provide feedback and participate in competitions.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
          <p className="leading-relaxed">
            We collect information about you to process your order, manage your account, and, if you agree, email you about other products and services we think may be of interest to you.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">How We Store Your Information</h2>
          <p className="leading-relaxed">
            We securely store your data on our servers located in [insert location]. We will keep your information for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Marketing</h2>
          <p className="leading-relaxed">
            We would like to send you information about products and services of ours that may be of interest to you. If you have consented to receive marketing, you may opt out at a later date.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Your Data Protection Rights</h2>
          <p className="leading-relaxed">
            You have the right to request copies of your personal data, to have your personal data corrected, to have your personal data erased, to restrict processing of your personal data, to object to processing of your personal data, and the right to data portability.
          </p>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Changes to Our Privacy Policy</h2>
          <p className="leading-relaxed">
            We keep our privacy policy under regular review and will place any updates on this web page. This privacy policy was last updated on [insert date].
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-4">How to Contact Us</h2>
          <p className="leading-relaxed">
            If you have any questions about our privacy policy or the data we hold on you, please do not hesitate to contact us.
          </p>
          <address className="mt-4">
            <p>Fatherhood Tech Inc.</p>
            <p>123 Tech Avenue</p>
            <p>Tech City, TX 12345</p>
            <p>Email: contact@fatherhoodtech.com</p>
          </address>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
